/**
 * Do not edit directly
 * Generated on Wed, 30 Aug 2023 11:19:23 GMT
 */

export const SDS_SPACE_XXXXSMALL = "0.125rem"; // XXXX-small space
export const SDS_SPACE_XXXSMALL = "0.25rem"; // XXX-small space
export const SDS_SPACE_XXSMALL = "0.5rem"; // XX-small space
export const SDS_SPACE_XSMALL = "0.75rem"; // X-small space
export const SDS_SPACE_SMALL = "1rem"; // Small space
export const SDS_SPACE_MEDIUM = "1.25rem"; // Medium space
export const SDS_SPACE_LARGE = "1.75rem"; // Large space
export const SDS_SPACE_XLARGE = "2.25rem"; // X-large space
export const SDS_SPACE_XXLARGE = "3rem"; // XX-large space
export const SDS_SPACE_XXXLARGE = "4rem"; // XXX-large space
export const SDS_SPACE_XXXXLARGE = "5rem"; // XXXX-large space
